import { SEARCH_PAGE_SIZE } from "../constants/CommonConstants";
import { TESTING_INSPECTOR_SEARCH_START_LOADING, TESTING_INSPECTOR_SEARCH_END_LOADING, TESTING_INSPECTOR_SEARCH_LOADED, SET_TESTING_INSPECTOR_FILTER } from "../constants/IneTestingInspectorConstants";
import { TESTING_INSPECTOR_START_LOADING, TESTING_INSPECTOR_END_LOADING, TESTING_INSPECTOR_LOADED } from "../constants/IneTestingInspectorConstants";

const initialState = {
    loading: false,
    list: {   
        dataList: []
        , searchList: []
        , totalCount: 0
    },
    filter: {
        pageIndex: 1,
        pageSize: SEARCH_PAGE_SIZE,
        search: "",
        active: ""
    },
    loadingFBO: false,
    fbo: null,
};

const IneTestingInspectorReducer = (state = initialState, action) => {
    switch(action.type) {
        case TESTING_INSPECTOR_SEARCH_START_LOADING:
            return {
                ...state,
                loading: true
            };
        case TESTING_INSPECTOR_SEARCH_END_LOADING:
            return {
                ...state,
                loading: false
            };
        case TESTING_INSPECTOR_SEARCH_LOADED:
            return {
                ...state,
                list: action.payload
            };
        case SET_TESTING_INSPECTOR_FILTER:
            return {
                ...state,
                filter: action.payload
            };
        case TESTING_INSPECTOR_START_LOADING:
            return {
                ...state,
                loadingFBO: true
            };
        case TESTING_INSPECTOR_END_LOADING:
            return {
                ...state,
                loadingFBO: false
            };
        case TESTING_INSPECTOR_LOADED:
            return {
                ...state,
                fbo: action.payload
            };
        default:
            return state;
    }
}

export default IneTestingInspectorReducer;